import React, { useState } from 'react';
import { userServices } from '../../APIServices/userServices';

function TopBar({
  crumbs,
  topSearch,
  setTopSearch,
  currentUserData,
}) {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const logoutAdmin = async (e) => {
    e.preventDefault();
    await userServices.logout({});
  };
  return (
    <div className="topbar">
      <div className="crumbs">
        {crumbs.map((c, i) => (
          <React.Fragment key={i}>
            <span className={i === crumbs.length - 1 ? 'cur' : ''}>
              {c}
            </span>
            {i < crumbs.length - 1 && (
              <i className="ti ti-chevron-right" />
            )}
          </React.Fragment>
        ))}
      </div>

      <div className="topbar-user">
        <button
          className="btn btn-ghost topbar-user-trigger"
          onClick={() => setShowUserMenu((prev) => !prev)}
        >
          <div className="user-avatar topbar-user-avatar">
            {currentUserData?.roleType === "admin" ? "A" : "SA"}
          </div>

          <span className="topbar-user-name">
            {[currentUserData?.firstName, currentUserData?.middleName, currentUserData?.lastName]
              .filter(Boolean)
              .join(" ")}
          </span>

          <i className="ti ti-chevron-down topbar-chevron" />
        </button>

        {showUserMenu && (
          <div className="card user-menu">
            <div className="user-menu-head">
              <div className="user-menu-name">
                {[currentUserData?.firstName, currentUserData?.middleName, currentUserData?.lastName]
                  .filter(Boolean)
                  .join(" ")}
              </div>

              <div className="user-menu-role">
                {currentUserData?.roleType === "admin" ? "Admin" : "Sub Admin"}
              </div>

              <div className="user-menu-email">
                {currentUserData?.email}
              </div>
            </div>

            <button
              onClick={logoutAdmin}
              className="btn btn-ghost user-menu-action"
            >
              <i className="ti ti-logout" />
              Sign Out
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default TopBar;
